<template>
  <select
    :id="id"
    class="ds-select"
    :class="{ invalid }"
    :value="value"
    :disabled="disabled"
    :aria-invalid="invalid ? 'true' : 'false'"
    @change="onChange($event.target.value)"
  >
    <option
      v-for="option in options"
      :key="String(option.value)"
      :value="option.value"
      :disabled="option.disabled"
    >{{ option.text }}</option>
  </select>
</template>

<script>
export default {
  name: 'DsSelect',
  props: {
    // [{ value, text, disabled? }] uses the same shape as b-form-select.
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // Matches DsInput / DsTextarea. Without it a required select stayed neutral after a
    // failed submit while the textarea beside it went red.
    invalid: {
      type: Boolean,
      default: false,
    },
    // Emit the picked value as a Number, since DOM values are always strings.
    number: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // input drives v-model; change mirrors b-form-select so existing @change wiring works.
    onChange(raw) {
      const next = this.number ? Number(raw) : raw
      this.$emit('input', next)
      this.$emit('change', next)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-select {
  @include ds-field;

  width: 100%;
  padding-right: 32px;
  font-weight: 600;
  color: $c-wine;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path d='M3 5l3 3 3-3' fill='none' stroke='%2329061B' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 11px center;
  background-size: 11px;

  &:focus { @include ds-focus-ring; }

  // No inset cover, or it would paint over the chevron above.
  @include ds-autofill-guard($c-white, $c-orange, false);

  &.invalid {
    border-color: $c-danger;
    background-color: $c-danger-light;

    &:focus { @include ds-focus-ring($c-danger); }

    @include ds-autofill-guard($c-danger-light, $c-danger, false);
  }

  &:disabled {
    background-color: $c-bg;
    color: $c-text-sec;
    cursor: not-allowed;

    @include ds-autofill-guard($c-bg, null, false);
  }
}
</style>
